import { render, staticRenderFns } from "./test-attachments.vue?vue&type=template&id=33bcfc45&scoped=true&"
import script from "./test-attachments.vue?vue&type=script&lang=js&"
export * from "./test-attachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bcfc45",
  null
  
)

export default component.exports